import { trainingAPI } from "@api/TrainingAPI";
import { audioMessage as message } from "@components/Common/Notifications/audioMessage";
import { buildTileRequest, createThrottledReporter, toLegacyStatTile } from "@utils/statTilesV2.mjs";

const reportError = createThrottledReporter(() => message.error("Could not load the stat tiles."));

/**
 * Load one stat tile from POST /api/v2/stat-tiles, in the legacy singleStatTileData shape.
 * `props` are buildTileRequest's. Return null when the API cannot express the tile, so
 * the caller asks the legacy endpoint instead.
 */
export const requestStatTile = (props) => () => {
	const tile = buildTileRequest(props);
	if (!tile) return null;
	return trainingAPI.getStatTile(tile).then(
		(answer) => {
			const statData = toLegacyStatTile(answer, { endDate: tile.end_date });
			if (!statData) throw new Error(`Stat tile ${tile.metric}: ${answer?.status}`);
			return statData;
		},
		(error) => {
			reportError();
			throw error;
		},
	);
};
